"use client"

import * as React from "react"
import { cn } from "@/lib/utils"

interface AnimatedHeroGraphicProps extends React.ComponentProps<"div"> {
  className?: string
}

export function AnimatedHeroGraphic({ className, ...props }: AnimatedHeroGraphicProps) {
  return (
    <div 
      className={cn("relative w-full h-full flex items-center justify-center", className)}
      {...props}
    >
      {/* Rotating outer ring */}
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-[300px] h-[300px] md:w-[400px] md:h-[400px] border-2 border-dashed border-accent/20 rounded-full animate-rotate-slow" />
      </div>

      {/* Floating cards */}
      <div className="relative w-full h-full">
        {/* Card 1 - Top left */}
        <div className="absolute top-0 left-0 w-24 h-24 md:w-32 md:h-32 bg-linear-to-br from-accent/20 to-accent-secondary/20 rounded-xl shadow-lg animate-float" />
        
        {/* Card 2 - Top right */}
        <div className="absolute top-8 right-8 w-20 h-20 md:w-28 md:h-28 bg-linear-to-br from-accent-secondary/20 to-accent/20 rounded-lg shadow-md animate-float-slow" style={{ animationDelay: '1s' }} />
        
        {/* Card 3 - Bottom left */}
        <div className="absolute bottom-8 left-8 w-28 h-28 md:w-36 md:h-36 bg-linear-to-br from-accent/15 to-accent-secondary/15 rounded-2xl shadow-xl animate-float" style={{ animationDelay: '2s' }} />
        
        {/* Card 4 - Bottom right */}
        <div className="absolute bottom-0 right-0 w-20 h-20 md:w-28 md:h-28 bg-linear-to-br from-accent-secondary/15 to-accent/15 rounded-lg shadow-lg animate-float-slow" style={{ animationDelay: '0.5s' }} />
      </div>

      {/* Decorative dot grid */}
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="grid grid-cols-3 gap-4 opacity-30">
          {[...Array(9)].map((_, i) => (
            <div key={i} className="w-2 h-2 rounded-full bg-accent" />
          ))}
        </div>
      </div>

      {/* Corner accent block */}
      <div className="absolute top-4 right-4 w-16 h-16 md:w-20 md:h-20 bg-accent rounded-lg shadow-accent-lg rotate-12" />
    </div>
  )
}
